import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";

import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";
import { FormControl } from "@mui/material";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { ClienteDropDown } from "../../../../../../common/domain/models/cliente_dropdown";

type Props = {
  contrato: string;
  projeto: string;
  idsCentroCusto?: number[],
  idsClientes?: number[],
  ddlCentroCusto: CentroCustoDropDown[],
  ddlCliente: ClienteDropDown[],
  onContratoChange: (v: string) => void;
  onProjetoChange: (v: string) => void;
  handleIdsCentroCustoChange: (v: number[]) => void,
  handleIdsClientesChange: (v: number[]) => void,
  onClear: () => void;
};

export const Header = ({
  contrato,
  projeto,
  ddlCliente,
  idsCentroCusto,
  ddlCentroCusto,
  idsClientes,
  onContratoChange,
  onProjetoChange,
  handleIdsCentroCustoChange,
  handleIdsClientesChange,
  onClear,
}: Props) => {
  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6 items-center justify-center">
        <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense">
          {/* Contrato */}
          <DefaultInput label="Pesquisar por Contrato" name="search_by_contrato" value={contrato ?? ""} onChangeValue={onContratoChange} />

          {/* Projeto */}
          <DefaultInput label="Pesquisar por Projeto" name="search_by_projeto" value={projeto ?? ""} onChangeValue={onProjetoChange} />

          {/* Cliente */}
          <div className="w-full">
              <DefaultMultiAutocomplete
                label='Cliente'
                value={ddlCliente.filter(x => idsClientes?.includes(x.id))}
                options={ddlCliente}
                getOptionLabel={x => x.title}
                getOptionKey={x => x.id}
                onChange={x => handleIdsClientesChange(x?.map(y => y.id) ?? [])} />
          </div>

          {/* Centro de Custo */}
          <div className="w-full">
              <DefaultMultiAutocomplete
                label='Centro de Custo'
                value={ddlCentroCusto.filter(x => idsCentroCusto?.includes(x.id))}
                options={ddlCentroCusto}
                getOptionLabel={x => x.title}
                getOptionKey={x => x.id}
                onChange={x => handleIdsCentroCustoChange(x?.map(y => y.id) ?? [])} />
          </div>
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClear}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
};
